import { render, staticRenderFns } from "./DefaultModal.vue?vue&type=template&id=6aca8888"
import script from "./DefaultModal.vue?vue&type=script&lang=js"
export * from "./DefaultModal.vue?vue&type=script&lang=js"
import style0 from "./DefaultModal.vue?vue&type=style&index=0&id=6aca8888&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports